import { getDataSourceLevel } from './common';
import { parseDataSource } from './dataFetcher';
import { DataSources } from '../../store/ast/ast.types';
import { RenderDataSource } from '../../store/data/data.types';
import { setRenderDataSource } from '../../store/common/action';

/**
 * 获取所有数据源的数据
 */
export async function findAllData(instanceId:string,dataSources: DataSources,renderDataSources:Map<string, RenderDataSource>,attrObject?:object, parameterType: any = undefined): Promise<void> {
  // 计算数据源层级
  const levels = getDataSourceLevel(dataSources);

  // 按层级排序数据源
  const sortedDataSources = dataSources.items.slice().sort((a, b) => {
    const levelA = levels.get(a.prop) || 0;
    const levelB = levels.get(b.prop) || 0;
    return levelA - levelB;
  });
  // 依次刷新每个数据源的数据
  for (const dataSource of sortedDataSources) {
    const renderData = await parseDataSource(dataSource, renderDataSources, attrObject, instanceId, parameterType);
    renderDataSources.set(dataSource.prop, renderData);
    setRenderDataSource(instanceId, dataSource.prop, renderData);
  }
}
